import { groupBy, map, sumBy } from 'lodash-es';
import { TypeSource } from 'views/Conversation/Sider/ToDoBundle/NewTodo';
import { officialTypeId } from 'views/Todo/hooks/useLabel';

/** 与 FormItem RelatedDescription 一致的订单商品分组：按 item___sku 汇总 quantity */
export function getTradeItems(selectedTrade?: Conversation.Trade.Vo) {
  const grouped = groupBy(selectedTrade?.items, (item) => {
    return `${item.externalItemId}___${item.externalSkuId}`;
  });
  return map(grouped, (items) => {
    const firstItem = items[0];
    return {
      ...firstItem,
      skuId: firstItem.externalSkuId,
      quantity: sumBy(items, 'quantity'),
    };
  });
}

/** 取当前订单默认关联商品（第一项）转 Todo.RelatedSku[] */
export function getTradeDefaultItem(selectedTrade?: Conversation.Trade.Vo): Todo.RelatedSku[] {
  if (!selectedTrade) return [];
  const item = getTradeItems(selectedTrade)?.[0];
  if (!item) return [];
  return [
    {
      skuName: item.skuName || '',
      sellerSku: item.sellerSku || '',
      quantity: item.quantity,
      itemId: item.externalItemId,
      itemName: item.itemName || '',
      skuId: item.externalSkuId || '',
    },
  ];
}

/** 从订单商品 refundReason 中收集退件单号列表 */
export function getReturnSnList(trade?: Conversation.Trade.Vo): string[] {
  if (!trade?.items) return [];
  return trade.items.reduce<string[]>(
    (res, { refundReason = [] }) =>
      refundReason.reduce((acc, { returnSn }) => {
        if (returnSn && !acc.includes(returnSn)) acc.push(returnSn);
        return acc;
      }, res),
    [],
  );
}

export const getTypeName = (type: Todo.Type, typeSource: TypeSource, typeName: string) => {
  if (type != null && !officialTypeId.includes(type) && type !== -998) {
    return typeSource.find((item) => item.type === type)?.typeLabel ?? typeName;
  }
  return typeName;
};
